import React, { FunctionComponent, useEffect, useState } from "react"
import moment from "moment"
import MomentUtils from "@date-io/moment"
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import { Toolbar, Typography } from "@material-ui/core"
import styles from "./ReportsPage.module.scss"

interface ReportsPageToolbarProps {
    updateDate: (date: moment.Moment) => void
}

export const ReportsPageToolbar: FunctionComponent<ReportsPageToolbarProps> = props => {
    const { updateDate } = props
    const [selectedDate, setDate] = useState<moment.Moment>(moment())

    useEffect(() => {
        updateDate(selectedDate)
    }, [])

    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <Toolbar disableGutters className={styles.ReportsPage__toolbar}>
                <Typography data-testid="reports-toolbar-title" variant="h6">
                    Usage Report
                </Typography>
                <DatePicker
                    inputProps={{ id: "reportsDatepicker" }}
                    data-testid="reports-toolbar-datepicker"
                    maxDate={new Date()}
                    variant="inline"
                    openTo="month"
                    views={["month", "year"]}
                    label="Year & Month"
                    value={selectedDate}
                    onChange={date => {
                        if (date) {
                            setDate(date)
                            updateDate(date)
                        }
                    }}
                />
            </Toolbar>
        </MuiPickersUtilsProvider>
    )
}
